export default {"src":"/_next/static/media/forward.003fdee4.svg","height":18,"width":273,"blurWidth":0,"blurHeight":0};